import { Loader, LoaderProps } from 'semantic-ui-react'
import styled, { css } from 'styled-components'

interface StyledLoaderProps extends LoaderProps {
  color?: string
}

const StyledLoader = styled(Loader)<StyledLoaderProps>`
  ${({ color }) => css`
    &&& {
      color: ${color || '#fff'} !important;

      :before {
        border-color: ${color || 'rgba(255, 255, 255, .15)'} !important;
      }

      :after {
        border-color: #fff transparent transparent;
      }
    }
  `}
`

export default StyledLoader
